import React from 'react'
import { Grid, Button, IconButton, Tooltip, Typography } from '@mui/material'
import { UseFormReturn, useFieldArray } from 'react-hook-form'
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { ControlledTextField } from "../../../../../components/forms";
import { OperacionNOTESFields, OperacionNOTESParametroFields } from '../types/fields';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

interface SeccionNuevoNOTESOtrosParametrosProps {
  formMethods: UseFormReturn<any>
}

const SeccionNuevoNOTESOtrosParametros = ({ formMethods }: SeccionNuevoNOTESOtrosParametrosProps) => {
  const { control } = formMethods

  const { fields, append, remove } = useFieldArray({
    control,
    name: OperacionNOTESFields.Parametros
  });

  const handleAgregarParametro = () => {
    append({
      [OperacionNOTESParametroFields.Titulo]: '',
      [OperacionNOTESParametroFields.Valor]: '',
      [OperacionNOTESParametroFields.Orden]: fields.length
    });
  }

  return (
    <CardActions
      title='Sección otros parámetros de la nota estructurada'
      icon='mdi:tune'
      colapsable
      actions={
        <Button
          variant='contained'
          size='small'
          startIcon={<AddIcon />}
          onClick={handleAgregarParametro}
        >
          Agregar Parámetro
        </Button>
      }
    >
      {fields.length === 0 ? (
        <Typography variant="body2" sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
          No hay parámetros adicionales agregados.
        </Typography>
      ) : (
        <SectionBox>
          {fields.map((item, index) => (
            <React.Fragment key={item.id}>
              <Grid item xs={12} md={5}>
                <ControlledTextField
                  label='Título'
                  name={`${OperacionNOTESFields.Parametros}.${index}.${OperacionNOTESParametroFields.Titulo}`}
                  control={control}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ControlledTextField
                  label='Valor'
                  name={`${OperacionNOTESFields.Parametros}.${index}.${OperacionNOTESParametroFields.Valor}`}
                  control={control}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Tooltip title="Eliminar Parámetro">
                  <IconButton color="error" onClick={() => remove(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </React.Fragment>
          ))}
        </SectionBox>
      )}
    </CardActions>
  )
}

export default SeccionNuevoNOTESOtrosParametros
